/* [Signature Legacy] Trust & Promise — Luxury Slider (Promise area) */

(() => {
  const ROOT_SEL = '[data-sigtrust]';

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  const setHeightToActive = (slidesEl, activeEl) => {
    if (!slidesEl || !activeEl) return;
    const h = Math.ceil(activeEl.getBoundingClientRect().height);
    slidesEl.style.minHeight = `${clamp(h, 72, 260)}px`;
  };

  const init = (root) => {
    const slidesWrap = root.querySelector('[data-sigtrust-slides]');
    if (!slidesWrap) return;

    const slides = Array.from(slidesWrap.querySelectorAll('.sigtrust__slide'));
    const dots = Array.from(root.querySelectorAll('.sigtrust__dot'));

    if (slides.length <= 0) return;

    let index = slides.findIndex(s => s.classList.contains('is-active'));
    if (index < 0) index = 0;

    const activate = (next) => {
      index = (next + slides.length) % slides.length;

      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.setAttribute('aria-selected', i === index ? 'true' : 'false'));

      setHeightToActive(slidesWrap, slides[index]);
    };

    // dots
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const to = Number(dot.dataset.dot || 0);
        activate(to);
        pauseAuto(9000);
      });
    });

    // first height
    requestAnimationFrame(() => setHeightToActive(slidesWrap, slides[index]));

    // autoplay (luxury pacing)
    const enableAuto = !prefersReducedMotion() && slides.length > 1;
    const intervalMs = 6200; // “딱 고급스럽게” 느린 전환 (너무 빠르면 싸 보입니다)

    let timer = null;
    let pausedUntil = 0;

    const tick = () => {
      if (!enableAuto) return;
      if (Date.now() < pausedUntil) return;
      activate(index + 1);
    };

    const startAuto = () => {
      if (!enableAuto) return;
      stopAuto();
      timer = setInterval(tick, intervalMs);
    };

    const stopAuto = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const pauseAuto = (ms) => {
      pausedUntil = Date.now() + ms;
    };

    // pause on hover/focus (premium behavior)
    root.addEventListener('mouseenter', () => pauseAuto(12000));
    root.addEventListener('focusin', () => pauseAuto(12000));

    window.addEventListener('resize', () => {
      setHeightToActive(slidesWrap, slides[index]);
    });

    // start
    activate(index);
    startAuto();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  });
})();
